import React, { useEffect } from "react";
import { number, string, func } from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";

import MyReportIcon from "../../../atoms/icons/my-report";
import FitConnect from "../../../atoms/icons/fit-connect";

import { setLoading } from "../../../helper/actions";

import "./ugcForm.m.css";

const UgcFormPageView = ({ meTypeUrl, metypeAccountId, publisherName, setLoading }) => {
  useEffect(() => {
    setLoading(true);

    window.talktype = window.talktype || function(f) { (talktype.q=talktype.q||[]).push(arguments);};   // eslint-disable-line

    const sc = document.createElement("script");
    sc.setAttribute("src", "https://fea.assettype.com/quintype-metype/assets/application.js");
    sc.setAttribute("type", "text/javascript");
    document.head.appendChild(sc);

    window.talktype(function () {
      window.talktype.contributionWidgetIframe(document.getElementById("contribution-container"));
      setLoading(false);
    });
  }, []);

  const getIcon = () => {
    if (publisherName === "fit") {
      return <FitConnect />;
    }

    return <MyReportIcon />;
  };

  return (
    <div styleName="wrapper">
      <div styleName="icon-wrapper">{getIcon()}</div>

      <div id="contribution-container" data-metype-account-id={metypeAccountId} data-metype-host={meTypeUrl}></div>
    </div>
  );
};

UgcFormPageView.propTypes = {
  metypeAccountId: number,
  meTypeUrl: string,
  publisherName: string,
  setLoading: func,
};

const mapStateToProps = (state) => ({
  metypeAccountId: get(state, ["qt", "config", "publisher-attributes", "metype_account_id"], null),
  meTypeUrl: get(state, ["qt", "config", "publisher-attributes", "metype_url"], null),
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

const UgcFormPage = connect(mapStateToProps, mapDispatchToProps)(UgcFormPageView);

export { UgcFormPage };
